import { heroTags } from '@/mocks/homeContent';

export default function Hero() {
  return (
    <section id="top" className="relative">
      <div className="relative h-[560px] w-full overflow-hidden md:h-[660px]">
        {/* background */}
        <img
          src="https://readdy.ai/api/search-image?query=overhead%20dramatic%20editorial%20flat%20lay%20of%20crumpled%20newspaper%20front%20pages%20and%20glossy%20magazines%20spread%20over%20dark%20charcoal%20studio%20table%2C%20one%20intense%20crimson%20red%20spotlight%20cutting%20diagonally%2C%20brass%20magnifying%20glass%20resting%20on%20printed%20text%2C%20scattered%20red%20seals%20and%20paper%20strips%2C%20deep%20black%20and%20warm%20red%20palette%2C%20cinematic%20chiaroscuro%20shadows%2C%20textured%20paper%20grain%2C%20moody%20tabloid%20investigation%20atmosphere%2C%20premium%20wide%20magazine%20composition&width=1600&height=900&seq=hero-main-2026&orientation=landscape"
          alt="1黑料网汇总专题主视觉"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/75 to-foreground-950/30"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-foreground-950/40"></div>

        {/* decorative vertical text */}
        <span className="absolute right-6 top-24 hidden select-none flex-col items-center gap-3 text-background-50/40 lg:flex">
          <span className="v-text text-[11px] tracking-[0.6em]">1黑料网 · 一网打尽精彩内容</span>
        </span>

        {/* content */}
        <div className="relative mx-auto flex h-full max-w-7xl flex-col justify-center px-4 md:px-6">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/90 px-3 py-1 text-xs font-semibold text-background-50 whitespace-nowrap">
              <span className="relative flex h-1.5 w-1.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50 opacity-75"></span>
                <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-background-50"></span>
              </span>
              今日全网热议 · 专题速览
            </span>

            <h1 className="mt-5 font-display text-4xl font-black leading-[1.08] text-background-50 md:text-6xl">
              1黑料网
              <span className="block text-xl font-bold text-background-50/90 md:text-3xl">
                汇总、合集、大盘点
                <span className="mx-2 inline-block rounded-sm bg-accent-400 px-2 py-0.5 align-middle text-base font-black text-foreground-950 md:text-xl">
                  一网打尽
                </span>
              </span>
            </h1>

            <p className="mt-6 max-w-xl text-sm leading-relaxed text-background-50/80 md:text-base">
              把每一条值得围观的现场、每一场值得回放的反转，都整理成看得懂的热门合集与精选盘点。
              疏而不散的专题浏览，每日更新，让你一次看个够。
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <a
                href="#featured"
                className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                浏览重磅合集
                <i className="ri-arrow-right-down-line text-base"></i>
              </a>
              <a
                href="#topics"
                className="inline-flex items-center gap-2 rounded-md border border-background-50/25 bg-background-50/10 px-5 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer backdrop-blur"
              >
                逛逛话题墙
                <i className="ri-grid-fill text-base"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* bottom tag ticker */}
      <div className="relative border-t border-background-200 bg-background-50">
        <div className="mx-auto flex max-w-7xl items-center gap-6 px-4 py-3 md:px-6">
          <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-primary-600 whitespace-nowrap">
            <i className="ri-fire-fill"></i> 热议
          </span>
          <div className="flex flex-1 flex-wrap items-center gap-2 overflow-hidden">
            {heroTags.map((t) => (
              <a
                key={t}
                href="#topics"
                className="inline-flex items-center gap-1 rounded-full bg-background-100 px-3 py-1 text-xs font-medium text-foreground-700 transition-colors hover:bg-accent-100 hover:text-accent-900 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-price-tag-3-line text-[10px]"></i>
                {t}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}